import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Alert,
} from 'reactstrap';
import IconButton from '~/components/IconButton';
import { copyStringToClipboard } from '~/util/copyToClipboard';

/**
 * Modal exibido após criar ou rotacionar uma PartnerApplication.
 *
 * Mostra o client_secret em plaintext UMA ÚNICA vez. Após fechar, o secret
 * nunca mais poderá ser recuperado — apenas rotacionado por um novo.
 *
 * Props:
 *   show, setShow
 *   clientId        string
 *   clientSecret    string
 *   isRotation      bool  (muda o título)
 *   onClose         function (chamada quando o usuário confirma que copiou)
 */
export default function SecretRevealModal({
  show,
  setShow,
  clientId,
  clientSecret,
  isRotation,
  onClose,
}) {
  const handleClose = () => {
    setShow(false);
    if (onClose) onClose();
  };

  const title = isRotation
    ? 'Novo Client Secret gerado'
    : 'Aplicação criada com sucesso!';

  return (
    <Modal
      isOpen={show}
      backdrop="static"
      size="lg"
      toggle={() => {}}
      keyboard={false}
    >
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>
        <Alert color="warning" className="d-flex align-items-start">
          <i
            className="las la-exclamation-triangle font-size-20 mr-2"
            style={{ flexShrink: 0 }}
          />
          <span>
            <strong>Armazene este Client Secret em local seguro.</strong>
            <br />
            Por motivos de segurança, ele{' '}
            <strong>não será exibido novamente</strong>. Caso perca o acesso,
            será necessário gerar um novo secret via rotação.
          </span>
        </Alert>

        {clientId && (
          <>
            <label className="font-weight-600 mb-1 mt-3">Client ID</label>
            <Row className="align-items-center justify-content-center mx-0">
              <Col xs={10} className="px-0">
                <input
                  type="text"
                  id="reveal-client-id"
                  className="w-100 form-control"
                  readOnly
                  value={clientId}
                  style={{
                    fontFamily:
                      '"JetBrains Mono", Menlo, Monaco, Consolas, monospace',
                    fontSize: '13px',
                  }}
                />
              </Col>
              <Col xs={2} className="px-0">
                <IconButton
                  id="copy-client-id"
                  icon="las la-copy"
                  containerClass="ml-2"
                  fontSize={28}
                  color="info"
                  click={() => {
                    copyStringToClipboard(clientId, 'Client ID copiado!');
                  }}
                  tip="Copiar"
                />
              </Col>
            </Row>
          </>
        )}

        <label className="font-weight-600 mb-1 mt-3">Client Secret</label>
        <Row className="align-items-center justify-content-center mx-0">
          <Col xs={10} className="px-0">
            <input
              type="text"
              id="reveal-client-secret"
              className="w-100 form-control"
              readOnly
              value={clientSecret}
              style={{
                fontFamily:
                  '"JetBrains Mono", Menlo, Monaco, Consolas, monospace',
                fontSize: '13px',
              }}
            />
          </Col>
          <Col xs={2} className="px-0">
            <IconButton
              id="copy-client-secret"
              icon="las la-copy"
              containerClass="ml-2"
              fontSize={28}
              color="info"
              click={() => {
                copyStringToClipboard(clientSecret, 'Client Secret copiado!');
              }}
              tip="Copiar"
            />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button
          className="new-layout-btn main"
          color="primary"
          onClick={handleClose}
        >
          Já copiei, fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
}
